import { LockPerson } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import React from 'react';

const PermissionMissing = () => (
  <Box display="flex" gap={1} alignItems="center">
    <LockPerson color="disabled" />
    <Typography color="textDisabled">Permission Missing</Typography>
  </Box>
);

export default PermissionMissing;
